module.exports = __webpack_public_path__ + "img/p5-p1-diaoxiang.0c03accb.png";